module.exports = __webpack_public_path__ + "img/icon-offset.d73ba5a8.svg";